const { default: Swal } = require("sweetalert2");
const { default: store } = require("../../store")
const { default: router } = require("../../router")
exports.install = function(Vue, options){
    Vue.prototype.com = {}
    Vue.prototype.com.needlogin = (role=null, path=null)=>{
        if(Vue.prototype.yet.user()){
            if(role){
                if(!Vue.prototype.yet.role(role.name)){
                    Swal.fire({text: role.msg, confirmButtonText: '知道了'})
                    return true;
                }
            }
            else{
                if(path){
                    router.push(path)
                }
                else{
                    return false;
                }
            }
        }
        else{
            window.document.getElementById('login-button').click()
            if(path){
                store.commit('set_return',path)
            }
            return true;
        }
    }
    Vue.prototype.com.var={role:{}}
    Vue.prototype.com.var.role.ind={
        name: 'ind',
        msg: '您不是个人用户，请注册个人用户操作'
    }
}